import { theme } from '@features/executive-report/domain/theme';
import { Slide, parseContent } from '@features/powerpoint';
import { ValueInput, formatters } from '@utils/formattersV2';
import { DEFAULT_FONT_SIZE } from './texts';
import { formatWithSign } from '@features/executive-report/utils/format-with-sign';

type KeyResultsTextsOptions = {
  totalIncrementalLift: ValueInput;
  projectedIncrementalSales: ValueInput;
  iroas: ValueInput;
};

export const keyResultsTexts = (
  options: KeyResultsTextsOptions
): NonNullable<Slide['texts']> => [
  {
    text: parseContent('TOTAL <b>INCREMENTAL LIFT %</b>'),
    options: {
      fontSize: DEFAULT_FONT_SIZE,
      color: theme.colors.white,
      h: 0.34,
      w: 3.12,
      x: 4.65,
      y: 2.68,
    },
  },
  {
    text: formatWithSign(options.totalIncrementalLift, value =>
      formatters.lift(value, { decimals: 2 })
    ),
    options: {
      fontSize: 36,
      color: theme.colors.white,
      h: 0.71,
      w: 3.18,
      x: 4.65,
      y: 2.95,
    },
  },
  {
    text: parseContent('PROJ. <b>INCREMENTAL SALES</b>'),
    options: {
      fontSize: DEFAULT_FONT_SIZE,
      color: theme.colors.white,
      h: 0.34,
      w: 3.11,
      x: 4.65,
      y: 4.09,
    },
  },
  {
    text: formatters.currency(options.projectedIncrementalSales),
    options: {
      fontSize: 44,
      color: theme.colors.inmarketGreen,
      h: 0.84,
      w: 3.28,
      x: 4.65,
      y: 4.4,
    },
  },
  {
    text: [
      {
        text: 'IROAS',
        options: {
          fontSize: DEFAULT_FONT_SIZE,
          color: theme.colors.white,
          bold: true,
          breakLine: true,
        },
      },
      {
        text: 'Incremental Return on Ad Spend'.toUpperCase(),
        options: {
          fontSize: 11,
          color: theme.colors.white,
        },
      },
    ],
    options: {
      fontSize: DEFAULT_FONT_SIZE,
      color: theme.colors.white,
      h: 0.52,
      w: 4.9,
      x: 4.65,
      y: 5.73,
    },
  },
  {
    text: formatters.currency(options.iroas, { decimals: 2 }),
    options: {
      fontSize: 36,
      color: theme.colors.white,
      h: 0.71,
      w: 3.19,
      x: 4.65,
      y: 6.15,
    },
  },
];
